import { analytics } from '@/lib/analytics'

const routeToPaywall = () => {
	analytics.paywallShown()
	window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'PAYWALL_ROUTE' }))
}

const openCameraAccessDialog = () => {
	window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'OPEN_CAMERA_ACCESS_DIALOG' }))
}

interface ShareContentPayload {
	text: string
	title?: string
}

const shareContent = (payload: ShareContentPayload) => {
	window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'SHARE_CONTENT', payload }))
}

export const jsBridge = {
	routeToPaywall,
	openCameraAccessDialog,
	shareContent,
}
